import styled from "@emotion/styled";
import { Pagination } from "@mui/material";
import { useState } from "react";
//import { useNavigate } from "react-router-dom";
import { 
//  GrayMapIcon,
  GrayClassAndBoardIcon
 } from "../../assets/icons/icons";
import useGetDetectDetail from "../../hooks/useGetDetectDetail";
import theme from "../../theme";
import SubHeader from "./subHeader";
import userStorage from "../../utils/userStorage";
import Spinner from "../../components/spinner";
import { SortArrow } from "../../components/sortArrow";
import PopUpMsg from "../../components/popUpMsg";
import { DotLoader } from "../../components/dotLoader";
import {
  formatDate,
  handleClickForSort,
  textSubstring,
} from "../../utils/util";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { PageLayout } from "../../components/PageLayout";
import { useWindowSize } from "@reactuses/core";
import { MobileDetecList } from "./mobileDetecList";
import { EventTag } from "../../components/EventTag";
import usePostDetectionDetailDownload from "../../hooks/usePostDetectionDetailDownload";
import { useSnackbar } from "notistack";
import { format } from "date-fns";
import EventDetailModal from "./EventDetailModal";
import { GetPastHistory } from "../../types/types";
import { useI18n } from "../../locales";
import {
  getEventTypeKey,
  getEventTypeValue,
  getMobilityTypeText,
} from "../../utils/langUtils";

export interface FetchParams {
  startDate: Date | null;
  endDate: Date | null;
  searchKey: string;
  mobFilter: number;
  detFilter: number;
  groupId: string;
}

export type DetectData = {
  header_seq: number;
  owner: string;
  device_pid: string;
  mobility_type: string;
  code_name: string;
  reason_dt?: string;
  reason?: string;
  checker_name?: string;
  latitude: number;
  longitude: number;
  registered_at: string;
  seq: number;
};
export interface DetectListRouteState {
  state: {
    from: string;
    data: DetectData;
  };
}

const { md } = theme.screen;

const DetectList: React.FC<{}> = () => {
  const { t } = useI18n();
  const user = userStorage.get();
  //const navigate = useNavigate();
  const { width } = useWindowSize();
  const [mobFilter, setMobFilter] = useState(-1); // 가짜
  const [detFilter, setDetFilter] = useState(0); // 진짜
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [page, setPage] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [sort, setSort] = useState<string | undefined>("");
  const [noData, setNoData] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [groupSubCode, setGroupSubCode] = useState(""); // 하위그룹코드(api용)
  const [openModal, setOpenModal] = useState(false);
  const [idx, setIdx] = useState<number>(0);
  const [detailData, setDetailData] = useState<GetPastHistory>();

  // 감지 내역 다운
  // const { mutate: postDown, isPending: downIsPending } =
  //   usePostDetectionDetailDownload();

  // const handlePost = () => {
  //   postDown(
  //     {
  //       startDate: format(startDate as Date, "yyyy-MM-dd"),
  //       endDate: format(endDate as Date, "yyyy-MM-dd"),
  //       page,
  //       searchKey,
  //       mobility_code: mobFilter,
  //       event_code: detFilter,
  //       area: user?.area as string,
  //       sort,
  //       limit: 10,
  //     },
  //     {
  //       onSuccess: async (data) => {
  //         // 만약 data가 없다면 에러 메시지를 표시하고 종료
  //         if (!data.data)
  //           enqueueSnackbar(`다운로드 가능한 파일이 없습니다.`, {
  //             variant: "error",
  //           });

  //         // Blob 데이터를 받아서 Blob URL을 생성 (파일을 다운로드할 수 있는 URL)
  //         const url = window.URL.createObjectURL(data.data);
  //         // <a> 태그를 동적으로 생성하여 다운로드 링크를 만듦
  //         const a = document.createElement("a");
  //         a.href = url;

  //         // content-disposition 헤더에서 파일명 추출
  //         const fileNameMatch = data.headers["content-disposition"].match(
  //           /filename\*=UTF-8''(.+)/
  //         );
  //         // 기본 파일명 설정
  //         let fileName = "default_filename.xlsx"; // 기본 파일 이름
  //         if (fileNameMatch && fileNameMatch[1]) {
  //           // 추출된 URL 인코딩된 파일명을 decodeURIComponent로 디코딩
  //           fileName = decodeURIComponent(fileNameMatch[1]);
  //         }
  //         a.download = fileName ? fileName : `download_file`;

  //         document.body.appendChild(a);
  //         a.click();

  //         // Blob URL을 해제하여 메모리에서 정리
  //         setTimeout(() => {
  //           window.URL.revokeObjectURL(url);
  //         }, 1000);
  //         a.remove();

  //         // 다운로드 성공 메시지를 로그인 유저에게 표시
  //         enqueueSnackbar(`파일 다운로드 성공`, {
  //           variant: "success",
  //         });
  //         return data;
  //       },
  //     }
  //   );
  // };

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  const { data, isLoading } = useGetDetectDetail({
    startDate,
    endDate,
    page,
    searchKey,
    mobility_code: mobFilter,
    event_code: detFilter,
    area: user?.area as string,
    sort,
    limit: 10,
    ...(groupSubCode &&
      groupSubCode !== "all" && { groupId: groupSubCode }),
  });

  // 감지 내역 다운
  const { mutate: postDown, isPending: downIsPending } =
    usePostDetectionDetailDownload();

  const handlePost = () => {
    postDown(
      {
        startDate: format(startDate as Date, "yyyy-MM-dd"),
        endDate: format(endDate as Date, "yyyy-MM-dd"),
        page,
        searchKey,
        mobility_code: mobFilter,
        event_code: detFilter,
        area: user?.area as string,
        sort,
        limit: 10,
      },
      {
        onSuccess: async (data) => {
          // 만약 data가 없다면 에러 메시지를 표시하고 종료
          if (!data.data)
            enqueueSnackbar(`다운로드 가능한 파일이 없습니다.`, {
              variant: "error",
            });

          // Blob 데이터를 받아서 Blob URL을 생성 (파일을 다운로드할 수 있는 URL)
          const url = window.URL.createObjectURL(data.data);
          // <a> 태그를 동적으로 생성하여 다운로드 링크를 만듦
          const a = document.createElement("a");
          a.href = url;

          // content-disposition 헤더에서 파일명 추출
          const fileNameMatch = data.headers["content-disposition"].match(
            /filename\*=UTF-8''(.+)/
          );
          // 기본 파일명 설정
          let fileName = "default_filename.xlsx"; // 기본 파일 이름
          if (fileNameMatch && fileNameMatch[1]) {
            // 추출된 URL 인코딩된 파일명을 decodeURIComponent로 디코딩
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
          a.download = fileName ? fileName : `download_file`;

          document.body.appendChild(a);
          a.click();

          // Blob URL을 해제하여 메모리에서 정리
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
          a.remove();

          // 다운로드 성공 메시지를 로그인 유저에게 표시
          enqueueSnackbar(`파일 다운로드 성공`, {
            variant: "success",
          });
          return data;
        },
      }
    );
  };

  const onClickBtn = ({
    startDate,
    endDate,
    searchKey,
    detFilter,
    mobFilter,
    groupId,
  }: FetchParams) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setSearchKey(searchKey);
    setDetFilter(detFilter);
    setMobFilter(mobFilter);
    setPage(0);
    setGroupSubCode(groupId);
  };

  // 감지내역 상세보기
  const onClickIcon = (seq: number) => {
    setIdx(seq);
    openDetailModal();
  };

  const openDetailModal = () => {
    setOpenModal(true);
  };

  // 기기정보 상세보기 모달 닫기
  const onCloseDetailModal = () => {
    setOpenModal(false);
  };

  // 지도에서 보기
  // const onClickMapIcon = (el: DetectData) => {
  //   // 좌표값 없는 경우 리턴
  //   if (!el.latitude || !el.longitude) {
  //     setNoData(true);

  //     setTimeout(() => {
  //       setNoData(false);
  //     }, 1000);
  //     return;
  //   }
  //   navigate(`/control/past`, {
  //     state: {
  //       from: "detectList",
  //       data: el,
  //       start: startDate,
  //       end: endDate,
  //       mobility_code: mobFilter,
  //       event_code: detFilter,
  //       searchKey,
  //     },
  //   });
  // };

  return (
    <PageLayout
      subHeader={
        width > md && (
          <SubHeader
            onClickBtn={onClickBtn}
            onClickDown={handlePost}
            downIsPending={downIsPending}
          />
        )
      }
      bodyPaddingBottom={width > md ? undefined : "0px"}
      withBreadcrumb
    >
      {width <= md && (
        <MobileDetecList
          data={data}
          isLoading={isLoading}
          sort={sort}
          setSort={setSort}
          setNoData={setNoData}
          onClickBtn={onClickBtn}
          onClickDown={handlePost}
          downIsPending={downIsPending}
          onClickDetailIcon={onClickIcon}
        />
      )}
      {width > md && (
        <>
          <BodyHeader>
            <span style={{ marginRight: "5px" }}>{t.history.searchedDetections} - </span>
            {isLoading && <DotLoader />}
            {!isLoading && data && <span>{data.total_items + ` ${t.history.casesUnit}`}</span>}
            {!isLoading && !data && <span>{`0 ${t.history.casesUnit}`}</span>}
          </BodyHeader>
          <TableHeader>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("header_seq", setSort);
              }}
              width={`70px`}
              disabled={data?.list.length === 0}
            >
              {t.history.detectionNumber} <SortArrow id="header_seq" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("mobility_type", setSort);
              }}
              width={`120px`}
              disabled={data?.list.length === 0}
            >
              {t.history.deviceType} <SortArrow id="mobility_type" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("mobility_name", setSort);
              }}
              width={`150px`}
              disabled={data?.list.length === 0}
            >
              {t.history.deviceName2} <SortArrow id="mobility_name" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("owner", setSort);
              }}
              width={`180px`}
              disabled={data?.list.length === 0}
            >
              {t.history.owner} <SortArrow id="owner" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("code_name", setSort);
              }}
              width={`130px`}
              disabled={data?.list.length === 0}
            >
              {t.history.detectionDetails} <SortArrow id="code_name" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("registered_at", setSort);
              }}
              width={`125px`}
              disabled={data?.list.length === 0}
            >
              {t.history.detectedDateTime} <SortArrow id="registered_at" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("reason_dt", setSort);
              }}
              width={`125px`}
              disabled={data?.list.length === 0}
            >
              {t.history.releasedDateTime} <SortArrow id="reason_dt" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("reason", setSort);
              }}
              width={`165px`}
              disabled={data?.list.length === 0}
            >
              {t.history.releaseReason} <SortArrow id="reason" state={sort} />
            </TableHeaderList>
            <TableHeaderList
              onClick={() => {
                handleClickForSort("checker_name", setSort);
              }}
              width={`70px`}
              disabled={data?.list.length === 0}
            >
              {t.history.actionTakenBy} <SortArrow id="checker_name" state={sort} />
            </TableHeaderList>
          </TableHeader>
          <TableBody>
            {isLoading && <Spinner />}
            {data &&
              data.list.length > 0 &&
              data.list.map((el) => (
                <TableList key={el.header_seq}>
                  {/* 감지 번호 */}
                  <Info
                    style={{
                      minWidth: "70px",
                    }}
                  >
                    {el.header_seq}
                  </Info>
                  {/* 기기 종류 */}
                  <Info
                    style={{
                      minWidth: "120px",
                    }}
                  >
                    {getMobilityTypeText(el.mobility_type, t)}
                  </Info>
                  {/* 기기명 */}
                  <CustomTooltip
                    title={el?.mobility_name}
                    active={el?.mobility_name?.length > 11}
                  >
                    <Info style={{ minWidth: "150px" }}>
                      {/* {textSubstring(el.mobility_name, 0, 11)} */}
                      {el.mobility_name}
                    </Info>
                  </CustomTooltip>

                  {/* 소유자 */}
                  <CustomTooltip
                    title={el?.owner}
                    active={el?.owner?.length > 16}
                  >
                    <Info style={{ minWidth: "180px" }}>
                      {/* {textSubstring(el.owner, 0, 11)} */}
                      {el.owner}
                    </Info>
                  </CustomTooltip>

                  {/* 감지내역 */}
                  <Info
                    style={{
                      minWidth: "130px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EventTag
                      text={(() => {
                        const eventKey = getEventTypeKey(el.code_name, t);
                        return eventKey && eventKey !== "normal"
                          ? getEventTypeValue(eventKey, t)
                          : el.code_name;
                      })()}
                      color={
                        (() => {
                          const eventKey = getEventTypeKey(el.code_name, t);
                          return eventKey === "vehicleRolloverEvent"
                            ? "red"
                            : "orange";
                        })()
                      }
                    />
                  </Info>

                  {/* 감지 일시 */}
                  <Info style={{ minWidth: "125px" }}>
                    {formatDate(el.registered_at, "yyyy-MM-dd HH:mm")}
                  </Info>

                  {/* 해제 일시 */}
                  <Info style={{ minWidth: "125px" }}>
                    {el.reason_dt
                      ? formatDate(el.reason_dt, "yyyy-MM-dd HH:mm")
                      : ""}
                  </Info>

                  {/* 해제 사유 (최대 20자) */}
                  <CustomTooltip
                    title={el?.reason}
                    active={el?.reason ? el?.reason?.length > 12 : false}
                  >
                    <Info style={{ minWidth: "165px", maxWidth: "165px" }}>
                      {/* {textSubstring(el.reason, 0, 15)} */}
                      {el.reason}
                    </Info>
                  </CustomTooltip>

                  {/* 조치자 */}
                  <CustomTooltip
                    title={el?.checker_name}
                    active={
                      el?.checker_name
                        ? el?.checker_name?.length > 4
                        : false
                    }
                  >
                    <Info
                      style={{
                        minWidth: "70px",
                      }}
                    >
                      {textSubstring(el.checker_name, 0, 4)}
                    </Info>
                  </CustomTooltip>

                  {/* 지도 아이콘 */}
                  <div>
                    {/* 감지내역 상세보기 아이콘 */}
                    <CustomTooltip title={t.history.detectionDetailView} active>
                      <IconWrapper
                        onClick={() => {
                          onClickIcon(el.header_seq);
                        }}
                      >
                        <GrayClassAndBoardIcon />
                      </IconWrapper>
                    </CustomTooltip>
                    {/* <CustomTooltip title={"지도에서 보기"} active>
                      <IconWrapper onClick={() => onClickMapIcon(el)}>
                        <GrayMapIcon />
                      </IconWrapper>
                    </CustomTooltip> */}
                  </div>
                </TableList>
              ))}
            {!isLoading && data && data.list.length === 0 && (
              <NoDataMassage>{t.history.noDataAvailable}</NoDataMassage>
            )}
          </TableBody>
        </>
      )}

      {!isLoading && (
        <PaginationFooter>
          <Pagination
            count={data?.total_page}
            page={page + 1}
            siblingCount={width <= md ? 1 : 3}
            onChange={handleChange}
            size={width <= md ? "small" : "medium"}
          />
        </PaginationFooter>
      )}

      { /* 감지내역 상세보기 모달 */ }
      {openModal && (
        <EventDetailModal
          open = {openModal}
          onPressNo = {onCloseDetailModal}
          seq = {idx}
          setDetailData = {setDetailData}
          detailData = {detailData}
        />
      )}

      <PopUpMsg
        open={noData}
        content={t.history.noLocationData}
      />
    </PageLayout>
  );
};

const BodyHeader = styled.h1`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  padding-bottom: 15px;
  border-bottom: 3px solid ${theme.color.neutral_200};
  display: flex;
  align-items: center;
`;
const TableHeaderList = styled.button<{ width: string }>`
  display: flex;
  justify-content: center;
  max-width: ${({ width }) => width};
  min-width: ${({ width }) => width};
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
  cursor: pointer;
  transition: 200ms;
  &:hover {
    font-weight: bold;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
`;

const IconWrapper = styled.button`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background: ${theme.color.neutral_200};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 200ms;
  &:hover {
    scale: 120%;
  }
`;

const TableHeader = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  padding-left: 20px;
  gap: 15px;
`;

const TableBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TableList = styled.div`
  background: ${theme.color.white};
  border-radius: 10px;
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  gap: 15px;
`;

const PaginationFooter = styled.footer`
  display: flex;
  justify-content: center;
  margin-top: 30px;

  @media (max-width: ${md}px) {
    height: 56px;
    margin-top: 0px;
    align-items: center;

    nav {
      padding: 14px 0px;
    }

    button {
      min-width: 28px;
      height: 28px;
      font-size: ${theme.fontSize.FONT_1};
      font-weight: ${theme.fontWeight.SEMI_BOLD};
      color: ${theme.color.neutral_500};
    }
  }
`;

const Info = styled.span`
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_600};
  text-align: center;
  white-space: normal;
  max-height: 46px;
  // 추가
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const NoDataMassage = styled.div`
  text-align: center;
  padding: 100px;
  color: ${theme.color.neutral_500};
`;
export default DetectList;
